export default __webpack_public_path__ + "static/media/backgroundMeiHao.72ea5521.jpg";